import Graph from "../util/graph";

const CollectionConcilationFinder = (
    collectionConcilation,
    allDates,
    isHotelSummed,
    isDateSummed,
    sHotels,
    options,
    isBar
) => {

    if (!isHotelSummed && !isDateSummed) {
        if (isBar) {
            return sHotels.map((hotel, index) => {
                return options.map((option, oIndex) => {
                    return {
                        label: `${hotel} Collection ${option}`,
                        data: allDates.map((date) => {
                            let data = collectionConcilation[hotel][date];
                            return data.reduce((acc, cur) => {
                                let types = Object.keys(cur.data).filter((t) =>
                                    t === option
                                );
                                return (
                                    acc +
                                    types.reduce((accc, curr) => {
                                        return accc + cur.data[curr].reduce((acccc, currr) => {
                                            return acccc + currr.effectiveValue
                                        }, 0);
                                    }, 0)
                                );
                            }, 0);
                        }),
                        borderColor: Graph.Colors[index + ((oIndex > 3 ? (oIndex - 3) : oIndex) * 10)],
                        backgroundColor: Graph.Colors[index + ((oIndex > 3 ? (oIndex - 3) : oIndex) * 10)],
                        ...Graph.ExtraOptions,
                        stack: `Stack Coll- ${hotel}`
                    };
                }).flat()
            }).flat()
        }

        return sHotels.map((hotel, index) => {
            return {
                label: `${hotel} Collection`,
                data: allDates.map((date) => {
                    let data = collectionConcilation[hotel][date];
                    return data.reduce((acc, cur) => {
                        let types = Object.keys(cur.data).filter((t) =>
                            options.includes(t)
                        );
                        return (
                            acc +
                            types.reduce((accc, curr) => {
                                return accc + cur.data[curr].reduce((acccc, currr) => {
                                    return acccc + currr.effectiveValue
                                }, 0);
                            }, 0)
                        );
                    }, 0);
                }),
                borderColor: Graph.Colors[index],
                backgroundColor: Graph.Colors[index],
                ...Graph.ExtraOptions,
            };
        })


    } else if (isHotelSummed && !isDateSummed) {

        if (isBar) {
            return options.map((option, oIndex) => {
                return {
                    label: `All Hotels ${option}`,
                    data: allDates.map((date) => {
                        return Object.keys(collectionConcilation).filter(hot => sHotels.includes(hot)).map(hot => collectionConcilation[hot]).map(dateData => {
                            return dateData[date]
                        }).flat().reduce((acc, cur) => {
                            let types = Object.keys(cur.data).filter(opt => opt === option)
                            return acc + types.reduce((accc, curr) => {
                                return accc + cur.data[curr].reduce((acccc, currr) => {
                                    return acccc + currr.effectiveValue
                                }, 0);
                            }, 0)
                        }, 0)
                    }),
                    borderColor: Graph.Colors[oIndex],
                    backgroundColor: Graph.Colors[oIndex],
                    ...Graph.ExtraOptions,
                    stack: `All Hotels Cols`
                }
            }).flat()
        }
        return [
            {
                label: "All Hotels Cols",
                data: allDates.map((date) => {
                    return Object.keys(collectionConcilation).filter(hot => sHotels.includes(hot)).map(hot => collectionConcilation[hot]).map(dateData => {
                        return dateData[date]
                    }).flat().reduce((acc, cur) => {
                        let types = Object.keys(cur.data).filter(opt => options.includes(opt))
                        return acc + types.reduce((accc, curr) => {
                            return accc + cur.data[curr].reduce((acccc, currr) => {
                                return acccc + currr.effectiveValue
                            }, 0);
                        }, 0)
                    }, 0)
                }),
                borderColor: Graph.Colors[0],
                backgroundColor: Graph.Colors[0],
                ...Graph.ExtraOptions,
            }
        ]
    } else if (!isHotelSummed && isDateSummed) {

        let hotels = Object.keys(collectionConcilation).filter(hot => sHotels.includes(hot))

        if (isBar) {
            return options.map((option, oIndex) => {
                return {
                    label: `All Dates ${option}`,
                    data: hotels.map(hotel => {
                        let allData = Object.keys(collectionConcilation[hotel]).map(date => {
                            return collectionConcilation[hotel][date].reduce((acc, cur) => {
                                let types = Object.keys(cur.data).filter(opt => opt === option)
                                return acc + types.reduce((accc, curr) => {
                                    return accc + cur.data[curr].reduce((acccc, currr) => {
                                        return acccc + currr.effectiveValue
                                    }, 0);
                                }, 0)
                            }, 0)
                        }).reduce((acc, cur) => {
                            return acc + cur
                        }, 0)
                        return allData
                    }),
                    borderColor: Graph.Colors[oIndex],
                    backgroundColor: Graph.Colors[oIndex],
                    ...Graph.ExtraOptions,
                    stack: `All Dates Cols`
                }
            })
        }
        return [
            {
                label: "All Dates Cols",
                data: hotels.map(hotel => {
                    let allData = Object.keys(collectionConcilation[hotel]).map(date => {
                        let dateData = collectionConcilation[hotel][date]
                        return dateData.reduce((acc, cur) => {
                            let types = Object.keys(cur.data).filter(opt => options.includes(opt))
                            return acc + types.reduce((accc, curr) => {
                                return accc + cur.data[curr].reduce((acccc, currr) => {
                                    return acccc + currr.effectiveValue
                                }, 0);
                            }, 0)
                        }, 0)
                    }).reduce((acc, cur) => {
                        return acc + cur
                    }, 0)
                    return allData
                }),
                borderColor: Graph.Colors[0],
                backgroundColor: Graph.Colors[0],
                ...Graph.ExtraOptions,
                stack: `All Cols`
            }
        ]
    } else if (isHotelSummed && isDateSummed) {
        let hotels = Object.keys(collectionConcilation).filter(hot => sHotels.includes(hot))
        if (isBar) {
            return options.map((option, oIndex) => {
                return {
                    label: `All Dates ${option}`,
                    data: [
                        hotels.map(hotel => {
                            let allData = Object.keys(collectionConcilation[hotel]).map(date => {
                                return collectionConcilation[hotel][date].reduce((acc, cur) => {
                                    let types = Object.keys(cur.data).filter(opt => opt === option)
                                    return acc + types.reduce((accc, curr) => {
                                        return accc + cur.data[curr].reduce((acccc, currr) => {
                                            return acccc + currr.effectiveValue
                                        }, 0);
                                    }, 0)
                                }, 0)
                            }).reduce((acc, cur) => {
                                return acc + cur
                            }, 0)
                            return allData
                        }).reduce((acc, cur) => {
                            return acc + cur
                        }, 0)
                    ],
                    borderColor: Graph.Colors[oIndex],
                    backgroundColor: Graph.Colors[oIndex],
                    ...Graph.ExtraOptions,
                    stack: "All Dates and Hotels Cols"
                }
            })
        }
        return [
            {
                label: "All Dates Cols",
                data: [
                    hotels.map(hotel => {
                        let allData = Object.keys(collectionConcilation[hotel]).map(date => {
                            return collectionConcilation[hotel][date].reduce((acc, cur) => {
                                let types = Object.keys(cur.data).filter(opt => options.includes(opt))
                                return acc + types.reduce((accc, curr) => {
                                    return accc + cur.data[curr].reduce((acccc, currr) => {
                                        return acccc + currr.effectiveValue
                                    }, 0);
                                }, 0)
                            }, 0)
                        }).reduce((acc, cur) => {
                            return acc + cur
                        }, 0)
                        return allData
                    }).reduce((acc, cur) => {
                        return acc + cur
                    }, 0)
                ],
                borderColor: Graph.Colors[0],
                backgroundColor: Graph.Colors[0],
                ...Graph.ExtraOptions,
            }
        ]
    }
}

export default CollectionConcilationFinder